/**
 * Test comment
 */
 const test = () => {
  console.log('lower');
};

export default test;